import { render, staticRenderFns } from "./data3.vue?vue&type=template&id=1144f21e&scoped=true&"
import script from "./data3.vue?vue&type=script&lang=js&"
export * from "./data3.vue?vue&type=script&lang=js&"
import style1 from "./data3.vue?vue&type=style&index=1&id=1144f21e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1144f21e",
  null
  
)

export default component.exports